import {
    CALL_QUALITY_SCORE_THRESHOLDS,
    CallOverallScoreBounds,
    OVERALL_SCORE_MAX,
    OVERALL_SCORE_MIN,
} from "@/types/call-overall-score-filter.types";

export const CALL_METRIC_FILTERS = ["gross", "net", "totalTime", "red", "yellow", "green", "scored"] as const;

export type CallMetricFilter = (typeof CALL_METRIC_FILTERS)[number];

const CALL_QUALITY_METRIC_FILTERS = ["red", "yellow", "green", "scored"] as const;

type CallQualityMetricFilter = (typeof CALL_QUALITY_METRIC_FILTERS)[number];

const isCallQualityMetricFilter = (metric: CallMetricFilter): metric is CallQualityMetricFilter =>
    CALL_QUALITY_METRIC_FILTERS.some((qualityMetric) => qualityMetric === metric);

/**
 * Maps agent-performance quality metrics to overall-score bounds.
 * Red: below 60 · Yellow: 60–79 · Green: 80+ · Scored: any scored call (0–100).
 */
export const resolveCallMetricOverallScoreBounds = (metric?: CallMetricFilter): CallOverallScoreBounds | undefined => {
    if (!metric || !isCallQualityMetricFilter(metric)) {
        return undefined;
    }

    const { yellowMin, greenMin } = CALL_QUALITY_SCORE_THRESHOLDS;

    if (metric === "red") {
        return {
            overallScoreMin: OVERALL_SCORE_MIN,
            overallScoreMax: yellowMin - 1,
        };
    }

    if (metric === "yellow") {
        return {
            overallScoreMin: yellowMin,
            overallScoreMax: greenMin - 1,
        };
    }

    if (metric === "green") {
        return {
            overallScoreMin: greenMin,
            overallScoreMax: OVERALL_SCORE_MAX,
        };
    }

    return {
        overallScoreMin: OVERALL_SCORE_MIN,
        overallScoreMax: OVERALL_SCORE_MAX,
    };
};
